import { Component, EventEmitter, OnDestroy, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { of, Subject } from "rxjs";
import { delay, switchMap, takeUntil } from "rxjs/operators";
import { Store } from "@ngrx/store";

import { ManagementFormBuilderService } from "@app/user/customization/management/management-form-builder.service";
import { CustomizationState } from "@app/user/customization/customization-store/customization.reducer";
import * as ManagementActions from "@app/user/customization/customization-store/management.actions";
import { ManagementFilterFormValue } from "@helper/abstraction/management";

@Component({
    selector: "app-user-filter",
    templateUrl: "./user-filter.component.html",
    styleUrls: ["./user-filter.component.scss"]
})
export class UserFilterComponent implements OnDestroy {
    @Output() public appFormValue: EventEmitter<ManagementFilterFormValue> = new EventEmitter<ManagementFilterFormValue>();
    public form: FormGroup;
    private unsubscribe$$: Subject<void> = new Subject<void>();

    constructor(
        private readonly store: Store<CustomizationState>,
        private readonly managementFormBuilderService: ManagementFormBuilderService,
    ) {
        this.form = this.managementFormBuilderService.getFilterForm();
        this.form.get("userStatuses")?.setValue([{ id: "ACTIVE", name: $localize`Активные` }]);
        this.store.dispatch(ManagementActions.updateManagementFilter(this.form.value));

        this.form.valueChanges.pipe(
            switchMap(el => of(el).pipe(delay(300))),
            takeUntil(this.unsubscribe$$)
        ).subscribe(value => {
            this.appFormValue.emit(value);
        });
    }

    public resetFilter(): void {
        this.form.setValue({
            fullName: null,
            login: null,
            userStatuses: [{ id: "ACTIVE", name: $localize`Активные` }]
        });
    }

    public ngOnDestroy(): void {
        this.unsubscribe$$.next();
        this.unsubscribe$$.complete();
    }
}
